import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {AppService} from '../app.service';
import {PriebezneHodnotenieGroup} from '../model/PriebezneHodnotenieGroup';

@Component({
    selector: 'app-priebezne-hodnotenie',
    templateUrl: './priebezne-hodnotenie.component.html',
    styleUrls: ['./priebezne-hodnotenie.component.css'],
    standalone: false
})
export class PriebezneHodnotenieComponent implements OnInit, OnDestroy {

  hodnotenia: PriebezneHodnotenieGroup[] = [];
  hodnoteniaSubscription = new Subscription();

  constructor(private appService: AppService) { }

  ngOnInit(): void {
    this.hodnoteniaSubscription = this.appService.priebezneHodnotenieSubject
      .subscribe((data: PriebezneHodnotenieGroup[]) => {
        this.hodnotenia = data;
      });

    this.hodnotenia = this.appService.getPriebezneHodnotenie();
  }

  ngOnDestroy(): void {
    this.hodnoteniaSubscription.unsubscribe();
  }

}
